import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ProductService } from '@suvo-bi-users';
import { IItemLookupTileDefinition } from '../../../interfaces/tiles/definitions/item-lookup-tile-definition.interface';
import { ITileComponent } from '../tile-component.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-item-lookup-tile',
  templateUrl: './item-lookup-tile.component.html',
  styleUrls: ['./item-lookup-tile.component.scss'],
})
export class ItemLookupTileComponent implements ITileComponent, OnInit {
  @Input() tileInstance: IItemLookupTileDefinition;

  referenceId: FormControl;

  allowed = false;

  private readonly router = inject(Router);
  private readonly productService = inject(ProductService);

  ngOnInit() {
    this.referenceId = new FormControl();

    if (this.tileInstance.dataSourceAlias) {
      this.allowed = this.productService.isFeatureEnabled('FINDANDPAGINATE', [
        'DATASOURCE:' + this.tileInstance.dataSourceAlias,
      ]);
    }
  }

  lookupItem() {
    this.router.navigateByUrl(
      `private/item/${this.tileInstance.dataSourceAlias}/${this.referenceId.value}`,
    );
  }
}
